import React                        from 'react';
import { smtPlacements as tooltip } from 'pu-data/Tooltips';
import TextComponent                from './TextComponent';

const SmtPlacements = (props) => {
  const name = 'smt';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="SMT<br />Placements"
      name={name}
      inputId={props.inputId}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      inputClassName={props.inputClassName}
      errorMessage={props.errorMessage} />
  );
};

SmtPlacements.defaultProps = {
  inputId: 'smt-placement',
};

export default SmtPlacements;
